import { Pagination } from "../Pagination/pagination";
import { useResource } from "hooks/resources/providers/resourceProvider";

export function DataTablePagination<T>() {
  const { data: result, pagination } = useResource<T>();

  if (result.totalPages === 0) return null;

  return (
    <Pagination
      totalCount={result.totalCount}
      currentPage={pagination.page}
      pageSize={pagination.pageSize}
      totalPages={result.totalPages}
      handlePageChange={pagination.setPage}
    />
  );
}
